import React, { useState, useEffect, useCallback } from 'react';
import axios from '../../api/api';
import { MdOutlineBlock } from 'react-icons/md';
import { FaSearch } from "react-icons/fa";
import { Link } from 'react-router-dom'
import Loader from '../Loader';
import { toast } from 'sonner';

const Customers = () => {

  const [customer, setCustomer] = useState([]);
  const [searchCustomer, setSearchCustomer] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searched, setSearched] = useState(false);
  const [selectedRequestId, setSelectedRequestId] = useState('');
  const [msisdn, setMsisdn] = useState('')
  const [user_type, setUser_type] = useState('')

  // Fetch all customers
  const getCustomers = useCallback(async () => {
    setLoading(true);
    setError(null);
    
    try {
      let query = ""

      if (!searchCustomer) {
        setLoading(false);
        return;
      }

      if (searchCustomer) {
        query += `?msisdn=${searchCustomer}`
      }

      const response = await axios.get(`/customer/${query}`);
      setCustomer(response.data.items);
      setLoading(false);
      setError(null);
    } catch (error) {
      console.log(error);
      setLoading(false);
      if (!error?.response?.status) {
        setError('Network error! Check your connection.');
      } else if (error.response.status === 400 || error.response.status === 404) {
        setError(error.response.data?.detail || 'Invalid request or resource not found');
      } else if (error.response.status === 500) {
        setError(error.response.data?.detail || 'Server error');
      } else {
        setError(error.response.data?.detail || 'Oops! Something went wrong! Try Again');
      }
    } finally {
      setLoading(false);
    }
  }, [searchCustomer]);


  // Handle search button click
  const handleSearch = () => {
    setSearched(true);
    getCustomers();
  };

  // Handle clearing search inputs
  const handleClearSearch = () => {
    setSearchCustomer('');
    setCustomer([]); 
    setSearched(false); 
  };

  // Fetch data only if a search has been performed
  useEffect(() => {
    if (searched) getCustomers();
  }, [getCustomers, searched]);

  // getting transaction by id
  const openModal = async (id) => {
    setSelectedRequestId(id);
    const dialog = document.getElementById('my_modal_3');
    if (dialog !== null) {
      dialog.showModal();
    }
  
    try {
      const response = await axios.get(`/customer/${id}/details`);
      setMsisdn(response.data.msisdn);
      setUser_type(response.data.user_type);
    } catch (error) {
      console.error("Error fetching transaction details:", error);
      toast.error("Failed to load transaction details.");
    }
  };

  // update customer
  const handleSubmit = async (e) => {
    e.preventDefault()
    const confirmed = window.confirm('Are you sure you want to update this customer');
    if (confirmed) {
      try {
        await axios.put(`/customer/${selectedRequestId}/details`, { user_type })
        toast.success('Customer Updated');
        getCustomers();
        // Close the modal
        const dialog = document.getElementById('my_modal_3');
        if (dialog) {
          dialog.close();
        }
      } catch (error) {
        if (!error?.response) {
          toast.error('No Server Response');
        } else if (error.response?.status === 400 || 404) {
          toast.error(error.response.data.detail);
        } else {
          toast.error('Failed to update customer!!');
        }
        console.log(error);
      }
    }
  }


  return (
    <div className='mx-auto p-4'>
      <h3 className="my-2"><b>Customers</b></h3>
      <div className='bg-white rounded-lg p-4 xl:w-[78vw] 2xl:w-full'>
        <div className='flex space-x-2 items-center mb-4'>
          <label htmlFor='search'><span className='hidden'>Search</span>
            <input
              type='text'
              id='search'
              className='px-3 py-1 w-full border bg-[#eef1ff] border-slate-300 placeholder-slate-400 rounded-md focus:outline-none focus:border-[#2b1e3e] focus:ring-[#2b1e3e] focus:ring-1'
              required
              placeholder='Search customer...'
              value={searchCustomer}
              onChange={(e) => setSearchCustomer(e.target.value)}
            />
          </label>
          <button
            onClick={handleSearch}
            className='px-4 py-1 bg-[#2b1e3e] text-white rounded-md'
          >
            Search
          </button>
          <button
            onClick={handleClearSearch}
            className='px-4 py-1 bg-red-500 text-white rounded-md'
          >
            Clear
          </button>
        </div>
        {loading ? (
          <div className='flex items-center justify-center bg-[#eef1ff] h-[70vh]'>
            <Loader />
          </div>
        ) : error ? (
          <div className='bg-[#eef1ff] grid place-items-center h-[70vh]'>
            <div className='grid place-items-center text-red-600 p-4'>
              <h3><MdOutlineBlock /></h3>
              <span>{error}</span>
            </div>
          </div>
        ) : (
          searched ? (
          <div className='overflow-x-auto rounded-lg'>
            {customer.length > 0
              ? (
                <table className='w-full text-left table-auto'>
                  <thead>
                    <tr className='border-b border-slate-500'>
                      <th className='p-2'>Phone Number</th>
                      <th className='p-2'>Commission</th>
                      <th className='p-2'>Net Value</th>
                      <th className='p-2'>Overdraft</th>
                      <th className='p-2'>Units Consumed</th>
                      <th className='p-2'>Points</th>
                      <th className='p-2'>Status</th>
                      <th className='p-2'>User Type</th>
                      <th className='p-2'>Created At</th>
                      <th className='p-2'>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {customer.map((customers) => (
                      <tr key={customers.id}>
                        <td className='p-2'>{customers.msisdn}</td>
                        <td className='p-2'>KES {customers.commission}</td>
                        <td className='p-2'>KES {customers.net_value}</td>
                        <td className='p-2'>KES {customers.overdraft}</td>
                        <td className='p-2'>KES {customers.unit_consumed}</td>
                        <td className='p-2'>{customers.points}</td>
                        <td className='p-2'>{customers.status}</td>
                        <td className='p-2'>
                          {customers.user_type === 1 ? (
                            <span>Customer</span>
                          ) : customers.user_type === 2 ? (
                            <span>Agent</span>
                          ) : (
                            <span>Dealer</span>
                          )}
                        </td>
                        <td className='p-2'>{new Date(customers.date_created).toLocaleString("en-CA", { hour12: false })}</td>
                        <td className='p-2 space-x-2'>
                          <Link to={`/customer/${customers.id}`}><span className='border border-[#1F2937] px-5 py-0.5 rounded-full'>View</span></Link>
                          <button
                            onClick={() => {openModal(customers.id)}}
                            className='bg-[#134463] text-white px-4 hover:bg-[#2b1e3e] rounded-full'
                          >
                            Update
                          </button>
                          <dialog id="my_modal_3" className="modal">
                            <div className="modal-box">
                              <form method="dialog">
                                {/* if there is a button in form, it will close the modal */}
                                <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2">✕</button>
                              </form>
                              <form onSubmit={handleSubmit}>
                                <div className='mt-2'>
                                  <label htmlFor=""><span>Phone Number</span>
                                  <input 
                                    type="number"
                                    placeholder="Amount"
                                    className='px-3 py-2 bg-white border border-slate-300 disabled:bg-neutral-100 placeholder-slate-400 focus:outline-none focus:border-[#2b1e3e] focus:ring-[#2b1e3e] w-full rounded-md focus:ring-1'
                                    value={msisdn}
                                    disabled
                                    onChange={(e) => {setMsisdn(e.target.value)}}
                                  />
                                  </label>
                                </div>
                                <div className='mt-2'>
                                  <label htmlFor=""><span>User Type</span>
                                  <select 
                                    name="user" id="user"
                                    className='px-3 py-2 bg-white border border-slate-300 disabled:bg-neutral-100 placeholder-slate-400 focus:outline-none focus:border-[#2b1e3e] focus:ring-[#2b1e3e] w-full rounded-md focus:ring-1'
                                    value={user_type}
                                    onChange={(e) => {setUser_type(e.target.value)}}
                                  >
                                    <option value="">User Type</option>
                                    <option value="1">Customer</option>
                                    <option value="2">Agent</option>
                                    <option value="3">Dealer</option>
                                  </select>
                                  </label>
                                </div>
                                <div className='mt-3 '>
                                  <button className='bg-[#134463] text-white px-4 py-0.5 hover:bg-[#134463dc] rounded-full'>Update</button>
                                </div>
                              </form>
                            </div>
                          </dialog>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div className='bg-[#eef1ff] text-[#134463] grid place-items-center h-[70vh]'>
                  <div className='grid place-items-center p-4'>
                    <h3><MdOutlineBlock /></h3>
                    <h4>No Data</h4>
                  </div>
                </div>
              )}
          </div>
          ) : (
            <div className='grid place-items-center h-[70vh]'>
              <div className='text-[#134463] p-4'>
                <h3 className='flex items-center justify-center'><FaSearch /></h3>
                <h4>Search Customer Details</h4>
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default Customers;